<blockable-div
    [blocked]="checkIfBlocked()"
    [blockUi]="blockUi"
    [attr.data-testid]="'line-item-list-blockable-wrapper'"
    [class]="flexClass"
>
    @if (model.id) {
        <app-widget-add-edit-line-item-list
            #addEditLineItemWidget
            [class]="listWidgetClass"
            [autoFocusSearch]="false"
            (onRefresh)="updateErrorCheckInDocument()"
            (itemsChanged)="onItemsChanged()"
            [document]="model"
            [dataTestId]="dataTestId()"
            [attr.data-testid]="'line-item-list-widget'"
            [noBaseEdit]="true"
            [showContractGenerateButton]="isContractDocumentEditor()"
            [contractGenerateDisabled]="contractGenerateDisabled()"
            [contractGenerateLoading]="contractGenerateLoading()"
            [contractGenerateTooltip]="contractGenerateTooltip()"
            [contractSaveLineItemsWithStockErrors]="contractSaveLineItemsWithStockErrors()"
            (contractGenerateClick)="onContractGenerateClick()"
            (contractSaveLineItemsWithStockErrorsChange)="onContractSaveLineItemsWithStockErrorsChange($event)"
        />
    }
</blockable-div>

<ng-template #blockUi>
    <p-button
        [loading]="isSaving"
        icon="fa fa-save"
        [label]="'document-line-item.save-document-first' | translate"
        (onClick)="saveToUnlockEditMode()"
        [disabled]="!model.address?.id && !model.addressId"
        [pTooltip]="
            !model.address?.id && !model.addressId
                ? ('document-line-item.choose-address-first-in-document' | translate)
                : ''
        "
        [attr.data-testid]="'save-document-to-unlock-edit-mode-btn'"
    ></p-button>
</ng-template>
